import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import DynamicForm from '../Form';

import './index.css';

import { sellCredits, revokeCredits } from '../../../_pages/Admin/Sellers/formData';


class ModalNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: props.showModal,
            centered: true
        };

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        this.resetSellCredits();
        this.resetRevokeCredits();
    }

    resetSellCredits() {
        sellCredits.map(
            (data, i) => {
                if (data.key === 'credits') {
                    data.value = '';
                }
            }
        )
    }

    resetRevokeCredits() {
        revokeCredits.map(
            (data, i) => {
                if (data.key === 'credits') {
                    data.value = '';
                }
            }
        )
    }

    toggle() {
        if (this.props.toggleEntireModal) {

            this.props.formData.map(val => {
                if (val.type !== 'hidden') {
                    val.value = ''
                    if (val.validation) {
                        if (val.validation.required) {
                            val.valid = false
                        }
                    }
                    if (val.fieldValidation) {
                        val.fieldValid = true
                    }
                }
            })
            this.props.toggleEntireModal(!this.state.modal)
        }
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {



        this.props.sellCredits &&
            sellCredits.map(
                (data, i) => {
                    if (data.key === 'instrument_id') {
                        data.value = this.props.instrumentId;
                    }

                }
            )

        this.props.revokeCredits &&
            revokeCredits.map(
                (data, i) => {

                    if (data.key === 'instrument_id') {
                        data.value = this.props.instrumentDetails.instrument__id;
                        data.maxCreditRevoked = this.props.instrumentDetails.unsold_credits
                        data.instrumentName = this.props.instrumentDetails.instrument__instrument_name
                    }
                }
            )

        return (
            <div>
                <Modal
                    isOpen={this.state.modal}
                    centered={this.state.centered}
                    style={{ maxWidth: '600px' }}
                >
                    <ModalHeader
                        toggle={this.props.hideClose ? null : this.toggle}
                        className="bg-black text-white text-uppercase custom-header"
                    >
                        {this.props.heading}
                    </ModalHeader>
                    <ModalBody>
                        {
                            this.props.revokeCredits &&
                            <p className="text-right"> You can revoke {this.props.instrumentDetails.unsold_credits} credits for {this.props.instrumentDetails.instrument__instrument_name}</p>
                        }
                        {
                            this.props.modalName === 'addRelation' &&
                            <p className="h4 pl-2" > Relation </p>
                        }

                        <DynamicForm
                            hideClose={this.props.hideClose}
                            formName={this.props.modalName}
                            data={this.props.formData}
                            action={this.props.action}
                            toggle={this.toggle.bind(this)}
                            relationToggle={this.props.relationToggle}
                            toggleRelationGroup={this.props.toggleRelationGroup}
                            reducer="updateSeller"
                            id={this.props.id}
                            isReset={this.props.isReset}
                            selects={this.props.selects}
                            selectKey={this.props.selectKey}
                            checkBoxData={this.props.checkBoxData !== undefined ? this.props.checkBoxData : null}
                            compartments={this.props.compartments !== undefined ? this.props.compartments : null}
                            viewMessageAdmin={this.props.viewMessageAdmin !== undefined ? this.props.viewMessageAdmin : undefined}
                        />

                    </ModalBody>
                </Modal>
            </div >
        );
    }
}

export default ModalNew;


// WEBPACK FOOTER //
// ./src/_components/common/ModalNew/index.jsx